export const getPieData = ({ stats, selectedPartner }) => {
    if (!stats || !selectedPartner) return null;

    const net = Number(stats.netProfitLoss);

    const partnerId = selectedPartner.id || "all";
    const name = selectedPartner.name || "Partner";

    // ✅ CASE 0: ALL partners
    if (partnerId === "all") {
        return {
            labels: ["Net Profit"],
            datasets: [
                {
                    data: [net],
                    backgroundColor: ["#16a34a"]
                }
            ]
        };
    }

    const myShare = Number(selectedPartner.myShare ?? 0);
    const partnerShare = Number(selectedPartner.partnerShare ?? (100 - myShare));

    // ✅ CASE 1: 100% Yours
    if (myShare >= 100) {
        return {
            labels: ["You"],
            datasets: [
                {
                    data: [net],
                    backgroundColor: ["#16a34a"]
                }
            ]
        };
    }

    // ✅ CASE 2: 100% Partner
    if (myShare <= 0) {
        return {
            labels: [name],
            datasets: [
                {
                    data: [net],
                    backgroundColor: ["#0ea5e9"]
                }
            ]
        };
    }

    // ✅ CASE 3: Shared (0 < share < 100)
    return {
        labels: ["You", name],
        datasets: [
            {
                data: [
                    net * (myShare / 100),
                    net * (partnerShare / 100)
                ],
                backgroundColor: ["#16a34a", "#0ea5e9"]
            }
        ]
    };
};